import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    if (value instanceof Date) {
      return value;
    }
    const parsed = moment(value, 'DD/MM/YYYY', true);
    return parsed.isValid() ? parsed.toDate() : null;
  }
}